<template>
  <div class="section-card">
    <div
      class="section-header"
      v-if="title || $slots.header"
    >
      <div class="section-title-area">
        <h3
          v-if="title"
          class="section-title"
        >
          {{ title }}
        </h3>
        <p
          v-if="description"
          class="section-description"
        >
          {{ description }}
        </p>
      </div>
      <div
        class="section-actions"
        v-if="$slots.actions"
      >
        <slot name="actions" />
      </div>
    </div>
    <div
      class="section-content"
      :class="{ 'no-padding': noPadding }"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  noPadding: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped lang="scss">
.section-card {
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  padding: var(--spacing-lg);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-base) var(--ease-out);
  position: relative;
  overflow: hidden;
  pointer-events: auto;
}

.section-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--panel-top-line);
  opacity: 0.9;
  pointer-events: none;
}

.section-card:hover {
  box-shadow: var(--shadow-md);
}

.section-card .section-title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-md);
  padding-bottom: var(--spacing-sm);
  border-bottom: 1px solid var(--color-border);
}

.section-card .section-header,
.section-card .section-content {
  pointer-events: auto;
}

.section-card .section-content {
  color: var(--color-text-primary);
}
</style>
